var PriceCard = Object.getPrototypeOf(app).PriceCard = new Component("priceCard");
PriceCard.debug = false;
PriceCard.createdAt      = "1.0.0";
PriceCard.lastUpdate     = "1.4.3";
PriceCard.version        = "1";
// PriceCard.loadingMsg     = "This message will display in the console when component will be loaded.";

// PriceCard.prototype.onCreate = function(){
  // do thing after element's creation
// }


// WEBPACK FOOTER //
// ./src/components/priceCard/priceCard.js